// Peer status pill — uses OMNI color tokens

interface StatusBadgeProps {
	status: "unassigned" | "assigned" | "revoked";
}

export function StatusBadge({ status }: StatusBadgeProps) {
	return (
		<span className="status-badge" data-status={status}>
			{status}
		</span>
	);
}
